// extracted by mini-css-extract-plugin
export default {"header":"EachTagGroup_header__Qn-ol","tagGroupName":"EachTagGroup_tagGroupName__whHrH","icon":"EachTagGroup_icon__CGgEv"};